import { defineStore } from 'pinia'
import { useChatStore } from 'stores/chatStore'
import { useUserManagementClientStoreStore } from 'stores/saasUserManagementClientStore'

export const useFullyLoadedAndLoggedInStore = defineStore('useFullyLoadedAndLoggedIn', {
  state: () => ({
    active: false,
    queue: [],
    inited: false,
    userManStore: undefined,
    chatStore: undefined,
    rounds: 0
  }),

  getters: {
    allLoaded () {
      return this.userManStore?.isLoggedIn && this.chatStore?.isLoggedIn
    }
  },
  actions: {
    registerCall ({ callFn }) {
      if (!this.inited) {
        this.userManStore = useUserManagementClientStoreStore()
        this.chatStore = useChatStore()
        this.inited = true
      }
      this.queue.push(callFn)
      void this.startLoginMonitor()
    },
    async startLoginMonitor () {
      if (this.active) {
        return
      }
      if (this.allLoaded) {
        await this.processAllCalls()
        return
      }
      this.rounds = 0
      this.active = true
      const TTT = this
      setTimeout(TTT.executeRound, 100)
    },
    async executeRound () {
      this.rounds += 1
      if (this.rounds > 100) {
        console.log('ERROR RJMDEBUG - waiting for fully logged in state but it never happened')
        // Resetting so it works next  time
        //  we clear the queue
        this.queue = []
        this.active = false
        return
      }
      if (!this.allLoaded) {
        const TTT = this
        setTimeout(TTT.executeRound, 100)
        return
      }
      await this.processAllCalls()
    },
    async processAllCalls () {
      while (this.queue.length > 0) {
        const item = this.queue.shift()
        await item({
          userManStore: this.userManStore,
          chatStore: this.chatStore
        })
      }
      this.active = false
    }
  }
})
